/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ at: NonNullable<unknown> }} Shop_Group_Edited_AtInputs */

const vi_shop_group_edited_at = /** @type {(inputs: Shop_Group_Edited_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Sửa lần cuối ${i?.at}`)
};

/**

* @param {Shop_Group_Edited_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_group_edited_at = /** @type {((inputs: Shop_Group_Edited_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Group_Edited_AtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_group_edited_at(inputs)
});